import { createInterfaceId } from '@gitlab/needle';
import { CliBackend } from './backend';

export interface BackendFactory {
  /**
   * @param existingSessionId - When present, the created backend resumes this
   *   session instead of creating a fresh workflow. Threaded per-create so
   *   session switching can supply arbitrary ids at runtime.
   */
  create(existingSessionId?: string): CliBackend;
}

export const BackendFactory = createInterfaceId<BackendFactory>('BackendFactory');
